export default "__VITE_ASSET__rxMiObA0__"